module.exports = __webpack_public_path__ + "img/photoAlbum3.9934c70d.jpg";